import { createFileRoute } from '@tanstack/react-router';

import { ManagedKeysPage } from '@/pages/managed-keys/managed-keys-page';

export const Route = createFileRoute('/managed-keys')({
  component: ManagedKeysPage,
});
